import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Loader, Card} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {advisorColumns} from '../../constants';
import {Actions} from '../../../common/actions';
import Header from '../common/Header';
import CommonTable from '../common/Table';
import './styles.scss';
import {UserGroup} from '../../../floatingInventory/constants/userGroup';

class AdvisorManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'filteredRows': 0,
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(this.props.permissions, resources.AdvisorManagement, scopes.See)
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    if (this.props.isUserTde) {
      this.props.setCurrentFlUserGroup(UserGroup.tdeUser);
    } else if (
      hasAccessPermission(this.props.permissions, resources.AdvisorManagement, scopes.Edit) &&
      hasAccessPermission(this.props.permissions, resources.AdvisorManagement, scopes.See) &&
      hasAccessPermission(this.props.permissions, resources.AdvisorManagement, scopes.Create)
    ) {
      this.props.setCurrentFlUserGroup(UserGroup.coachDealer);
    } else {
      this.props.setCurrentFlUserGroup(UserGroup.adviserDealer);
    }

    this.props.fetchAdvisorManagementList(this.props.dealerId);
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  renderLoader() {
    return (
      <Table striped className="toyota-grid">
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan="100%">
              <Loader active inline="centered" content="Ejecutando" />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {filteredRows} = this.state;
    const {loading, list} = this.props;
    const isAvailable = ([UserGroup.coachDealer, UserGroup.tdeUser].includes(this.props.currentFlUserGroup));
    return (
      <div className="advisor-admin-container">
        <Header
          title="Administración de Asesores"
          name="cliente"
          filteredRows={filteredRows}
          detail=""
          saveChanges=""
          contentType="advisor"
        />
        <Card raised fluid className="processed-warranty-table">
          {loading ? (
            this.renderLoader()
          ) : (
            <CommonTable
              filteredRows={filteredRows}
              list={list}
              columnsTable={advisorColumns({
                isAvailable,
              })}
              handleChange={this.handleChange}
            />
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'list': state.advisorManagment.list,
    'loading': state.advisorManagment.loading,
    'currentFlUserGroup': state.floatingInventory.currentFlUserGroup,
    'dealerId': state.session.dealerId,
  };
};

const {
  withRouter,
  fetchTwcList,
  clearTwcList,
  fetchFileData,
  fetchWarrantySequences,
  fetchWarrantyStatus,
  addWarrantyChecked,
  removeWarrantyChecked,
  fetchAdvisorManagementList,
  navigateTo,
  setCurrentFlUserGroup,
} = Actions;

const mapDispatchToProps = {
  fetchTwcList,
  fetchFileData,
  clearTwcList,
  fetchWarrantySequences,
  fetchWarrantyStatus,
  addWarrantyChecked,
  removeWarrantyChecked,
  fetchAdvisorManagementList,
  navigateTo,
  setCurrentFlUserGroup,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdvisorManagement)
);
